import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import DateTime from 'react-datetime';

const ModalLote = ({lote, onclose, data, idx, idxLote, setForm}) => {

  const [tmpLote, setTmpLote] = useState(lote);

  const onChangeLote = (e) => {
    let lote = { ...tmpLote };

    lote[e.target.name]._text = e.target.value;

    if((e.target.name == 'qLote')&&(e.target.name != '')){
      lote[e.target.name]._text = parseInt(lote[e.target.name]._text);
    }

    setTmpLote(lote);
  }

  const onChangeDate = (e, name) => {
    let lote = { ...tmpLote };

    if (e.length != undefined) {
      if (e.length === 2) {
        lote[name]._text = e + '/'
      } else if (e.length === 5) {
        lote[name]._text = e + '/'
      } else if (e.length >= 6 && e.length <= 10) {
        lote[name]._text = e
      } else if (e.length > 10) {
        lote[name]._text = lote[name]._text
      }
    }else{
      lote[name]._text = e.format('DD/MM/YYYY');
    }


    setTmpLote(lote);
  }

  const gravarLote = () => {
    let dt = data;

    dt.map(linha => {

      if (linha.idx == idx) {
      
        if(idxLote == -1){
          if(Array.isArray(linha.det.prod.rastro)){
            linha.det.prod.rastro.push(tmpLote);
          }else if(linha.det.prod.rastro){
            linha.det.prod.rastro = [linha.det.prod.rastro, tmpLote];
          }else{
            linha.det.prod.rastro = tmpLote;
          }
        }else{
          linha.det.prod.rastro = tmpLote;
        }
      }
    })
    
    setForm(dt);
    onclose();
  }

  return (
    <>
      <ModalHeader>Edição de Lotes</ModalHeader>
      <ModalBody>
        <Row>
          <Col >
            <FormGroup className="mb-0">
              <Label>Lote</Label>
              <Input
                name="nLote"
                placeholder="Número do Lote"

              onChange={onChangeLote}
              defaultValue={tmpLote.nLote._text}

              />
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
            <Label>Qtde</Label>
              <NumberFormat
                className="form-control"
                name="qLote"
                id="qtde_lote"
                type="text"
                placeholder="0"
                //mask="_"
                // format="R$ ###,##"                
                // decimalSeparator={','}
                //onBlur={onChangeEscalonado('preco_escalonado')}
                value={tmpLote.qLote._text}
                onChange={onChangeLote}
                // fixedDecimalScale
                
              />
            </FormGroup>
          </Col>

         <Col>
            <FormGroup>
            <Label>Fabricação</Label>
              <DateTime
                value={tmpLote.dFab._text != '' ? tmpLote.dFab._text : ''}
                dateFormat="DD/MM/YYYY"
                placeholder="Data de Fabricação"
                onChange={(e) => onChangeDate(e, 'dFab')}
                timeFormat={false}
                closeOnSelect={true}
              // inputProps={{ disabled: configFieldDetPromo.inicio_promocao }}
              >
              </DateTime>
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
            <Label>Validade</Label>
              <DateTime
                value={tmpLote.dVal._text != '' ? tmpLote.dVal._text : ''}
                dateFormat="DD/MM/YYYY"
                placeholder="Data de Validade"
                onChange={(e) => onChangeDate(e, 'dVal')}
                timeFormat={false}
                closeOnSelect={true}
              // inputProps={{ disabled: configFieldDetPromo.inicio_promocao }}
              >
              </DateTime>
            </FormGroup>
          </Col>

        </Row>
      </ModalBody> 

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button color="success" onClick={gravarLote}>Gravar</Button>{' '}
            <Button color="danger" onClick={onclose}>Fechar</Button>
          </Col>
        </Row>
      </ModalFooter>
    </>
  )
}

export default ModalLote;